export default {
  list: {
    banner: {
      title: "Industry Solutions",
      subtitle:
        "We provide professional solutions for different industries and application areas to enhance the productivity of enterprises.",
    },
    "hot-solution": {
      title: "Popular Solutions",
      subtitle:
        "Aiming at the characteristics of the Internet, finance, government and enterprises, manufacturing, education and other fields, we will create personalized industry solutions.",
      "common-detial": "Learn more",
      education: {
        title: "Education",
        subtitle:
          "A safe and seamless student experience that protects students and staff.",
      },
      game: {
        title: "Game",
        subtitle:
          "Players come in fast and keep hackers away. Fast logins from multiple identity sources, and ensure user access to sensitive information.",
      },
      it: {
        title: "Software",
        subtitle:
          "One authentication multipoint interconnection, one software global monitoring.",
      },
      govenment: {
        title: "Government",
        subtitle:
          "Authing allow users to access all systems with one account and log in securely to government services.",
      },
      finance: {
        title: "Finance",
        subtitle:
          "Enable Financial Cloud, an intuitive and visual analytics platform that complies with national regulatory standards.",
      },
      publisher: {
        title: "Publishing",
        subtitle:
          "Keep readers focused and hundreds of millions of users in control.",
      },
      medical: {
        title: "medical",
        subtitle: "A medical system that satisfies patients.",
      },
    },
    customer: {
      title: "Authing's Representative Customers",
    },
  },
  detail: {
    "label-medical": "Healthcare",
    "label-government": "Public Sector",
    "label-education": "Education",
    "label-finance": "Finance",
    "label-game": "Game",
    "label-software": "Software",
    "label-publisher": "Publishing",
    "label-enterprise": "Enterprise",
    "title-challenge": "Industry Challenges",
    "title-value": "Solution Value",
    "button-consult": "Solution consultation",
    medical: {
      title: "Healthcare Solution",
      sub:
        "Unified digital identity to provide standardized, integrated and open medical data services for medical institutions.",
      challenges: {
        "item-one": {
          title: "Protect data privacy, enhance patient trust",
          content:
            'The personal data of citizens are scattered in countless medical systems, which can easily cause the leakage of personal information. Since the "Administrative Measures for Information Disclosure of Medical and Health Service Units (Trial)" was passed in 2010, it has stipulated that the health and traditional Chinese medicine administrative departments of local people\'s governments at or above the county level shall establish and improve the accountability system for information disclosure of medical and health service units, and Supervise, manage and punish "disclosure of information that should not be disclosed, or deliberate the disclosure of the identification information of service objects and personal privacy.',
          icon: "icon authing-icon authing-weisheng icon-style",
        },
        "item-two": {
          title: "Poor medical experience",
          content:
            "In the medical system, all citizens have separate accounts. This not only means that patients need to log in with different accounts and passwords repeatedly in multiple medical institutions, but also means that personal allergy history, medical insurance records, etc. are stored in different systems, resulting in the fragmentation of personal data by the system.",
          icon: "icon authing-icon authing-duochongshenfen icon-style",
        },
        "item-three": {
          title: "Poor medical staff experience",
          content:
            "It is also difficult for the staff of medical units to access the medical system. They need to remember different passwords in each system, such as the registration system, charging system, inpatient system, pharmacy system, medical equipment system, etc. Moreover, with the increasing number of systems and the continuous change of medical personnel, it is also a difficult task to manage the identity of all personnel. Each change means that the system needs to be added, deleted, modified, and checked again and again.",
          icon: "icon authing-icon authing-butongxitong icon-style",
        },
        "item-four": {
          title: "Scalability and security of the medical system",
          content:
            "Whenever the medical system needs to integrate medical services with new cooperative units, it is necessary to redevelop new interfaces in order to barely enhance the expansion ability, and the expanded service interfaces are difficult to meet the identity security standards.",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Protect data privacy, enhance patient trust",
          content:
            'When processing personal information, authing adopts data encryption and unified management to ensure the data security and data sovereignty of patients, so that any medical system can quickly comply with the "management measures for information disclosure of medical and health service units (Trial)", protect the data privacy of patients and enhance the trust of patients on medical services.',
          icon: "icon authing-icon authing-shujuyinsi icon-default",
        },
        "item-two": {
          title: "Digital medical experience that everyone loves",
          content:
            "Patients do not need to remember the password, or just remember a password, can log into each medical system, so that patients no longer need to forget the password and delay the disease. Moreover, medical institutions do not need to develop or operate and maintain. They can open their faces and fingerprints on one key, or login in to any medical system by Alipay or WeChat.",
          icon: "icon authing-icon authing-yiyuan icon-default",
        },
        "item-three": {
          title: "Unifying medical system to reduce pressure for medical staff",
          content:
            "Authing unifies all personnel and software in the medical system. No matter where employees store it, no matter who developed the software (even old software), authing can easily connect any user and application. Authing optimizes the digital experience of medical practitioners.",
          icon: "icon authing-icon authing-tongyixitong icon-default",
        },
        "item-four": {
          title:
            "Starting from the medical system, expanding the human-centered smart city",
          content:
            "Authing can integrate patients in different hospitals and medical systems, create a unified identity experience, and manage all people in different health systems. Patients can access their health records with an account, test results with a card, and so on. This kind of medical experience will be the breakthrough point of urban modernization and digitization. Using Authing, the city can start from the medical system, integrate high-quality login experience and efficient citizen governance into any city service, and build a smart city with people as the center.",
          icon: "icon authing-icon authing-zhihuichengshi icon-default",
        },
      },
      support: {
        title: "How Authing supports the medical industry",
      },
    },
    game: {
      title: "Game Solution",
      sub:
        "Let the players come in quickly, let the hackers stay away, and make a safe pop game.",
      challenges: {
        "item-one": {
          title: "Security and user experience cannot be balanced",
          content:
            "Simple login design and easy authentication process do not mean sacrificing user experience and leaving no security risks",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        "item-two": {
          title: "Difficulty in access control",
          content:
            "There are groupings in various formats in multiplayer games, and permission control becomes particularly difficult. The permission issue makes every game company a headache.",
          icon: "icon authing-icon authing-management icon-style",
        },
        "item-three": {
          title: "The higher the willingness to pay, the more game fraud",
          content:
            "With the continuous development of the gaming industry, people's electronic games have become longer and longer, and their willingness to pay has become higher. At the same time, fraud in the game has become more serious, and users' property interests are easily violated.",
          icon: "icon authing-icon authing-Consume icon-style",
        },
        "item-four": {
          title:
            "User system development cycle is long, affecting the online game",
          content:
            "User system and identity authentication are not the core of development, but they are also a very important link. Lengthy user system development time will greatly delay the launch time of the game.",
          icon: "icon authing-icon authing-zhouqi icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Keep it safe and have fun",
          content:
            "Authing does not allow companies or developers to choose between security and user experience. You can configure the two-step authentication strategy and choose the authentication method that suits your users.",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-two": {
          title: "Identity authentication, from complex to simplified",
          content:
            "Authing can be easily implemented in any heterogeneous environment, no matter what language or technology stack. Authing provides software development kits (SDKs) and application interfaces (APIs) in 10+ mainstream languages, and it is convenient for you to quickly deploy Authing in public or hybrid clouds.",
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        "item-three": {
          title: "Authority management, flexible and powerful",
          content:
            "RBAC and ABAC-based permission control are more flexible and powerful. The permissions of each user are controlled by the roles you create.",
          icon: "icon authing-icon authing-management icon-default",
        },
        "item-four": {
          title: "Rapid deployment, speed up the game",
          content:
            "Quickly deploy the identity link, speed up the game launch, reduce development man-hours related to certification by 51%, and reduce operation and management time by 200 hours.",
          icon: "icon authing-icon authing-Smooth icon-default",
        },
      },
      support: {
        title: "How Authing supports the game industry",
      },
    },
    software: {
      title: "Technology Solution",
      sub:
        "One time authentication, multi-point interconnection and one software global monitoring.",
      challenges: {
        "item-one": {
          title: "Low development efficiency and serious cost waste",
          content:
            "Product development is very slow. Every time we develop an application, we have to develop a user system, and the implementation is complex, and the ability to face different scenarios is not the same, and both time and labor costs are highly wasteful.",
          icon: "icon authing-icon authing-highcost icon-style",
        },
        "item-two": {
          title: "Security faces huge challenges",
          content:
            "With the increase of security risks, errors in the management of identity authentication users are often fatal. At present, there are security and authentication professionals who can master various authentication protocols. It is rare, expensive and expensive.",
          icon: "icon authing-icon authing-Safety icon-style",
        },
        "item-three": {
          title: "Missed growth opportunities",
          content:
            "In the application matrix, different platforms will be developed, which will cause our users to be scattered among the platforms with different login methods, and even need to attract each other's different products, leading to missed growth opportunities.",
          icon: "icon authing-icon authing-jihui icon-style",
        },
        "item-four": {
          title: "Expensive maintenance costs",
          content:
            "Cloud technology, artificial intelligence, big data, identity and many other technologies continue to be updated, and the internal system update speed to be equal to the industry requires expensive maintenance costs and continuous development and innovation capabilities, as well as more time and labor costs.",
          icon: "icon authing-icon authing-low-cost icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Accelerate product landing and reduce development costs",
          content:
            "Authing accelerates product research and development, speeds up business launches, reduces certification-related development man-hours by 51%, reduces operation and management time by 200 hours, allows products to be quickly implemented and realizes business value.",
          icon: "icon authing-icon authing-low-cost icon-default",
        },
        "item-two": {
          title: "Eliminate identity risks, safe and trustworthy",
          content:
            "To hedge against security risks, professional matters should be entrusted to professional people, and the identity link should be entrusted to professional people to hedge security risks. Adaptive MFA functions such as dynamic tokens and face recognition are available to you instantly, out of the box, and trustworthy.",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-three": {
          title: "Increasing corporate income, the software generates value",
          content:
            "Promote business growth, centrally manage users from all sources, and increase user experience to create cross-selling opportunities, increase corporate revenue, and achieve customer success.",
          icon: "icon authing-icon authing-value icon-default",
        },
        "item-four": {
          title: "Continuous innovation and iteration, identity out of the box",
          content:
            "Provides a cross-platform, 10+ language software development kit (SDK) and the application interface (API), which can quickly and safely integrate user authentication into various applications. Have a professional team to carry out product version iteration and innovative technology updates, and quickly synchronize to all users。",
          icon: "icon authing-icon authing-chuangxin icon-default",
        },
      },
      support: {
        title: "How Authing supports the technology industry",
      },
    },
    government: {
      title: "Public Sector Solution",
      sub:
        "Let citizens access all systems with one account and log in to government services safely.",
      challenges: {
        "item-one": {
          title: "Data isolation, decentralized security",
          content:
            "Identity data is scattered on different platforms, and each department has its own departmental system and process. In government affairs, different systems and processes will reduce the coordination and organization of work and greatly reduce work efficiency and coordination.",
          icon: "icon authing-icon authing-shujufensan icon-style",
        },
        "item-two": {
          title: "High maintenance costs and limited functions",
          content:
            "Cloud technology, artificial intelligence, big data, identity and other technologies continue to be updated. Synchronous updates of government internal systems require expensive maintenance costs and continuous development and innovation capabilities. At the same time, many functions are restricted due to technical reasons.",
          icon: "icon authing-icon authing-highcost icon-style",
        },
        "item-three": {
          title: "The deployment environment is complex",
          content:
            "Different software deployed in different cloud environments will face intricate management situations such as multi-cloud and hybrid cloud, which will make management extremely difficult.",
          icon: "icon authing-icon authing-deploy icon-style",
        },
        "item-four": {
          title: "Citizen experience needs continuous improvement",
          content:
            "Serving people is the primary task of governments at all levels. At the same time as the digital reform of the government, the user experience of citizens has also become an important challenge. It is necessary to provide citizens with more flexible digital services and fast online services. At the same time, it is necessary to consider the needs of citizens of different ages, different attributes, and different businesses, so that digital government services can provide a quality life for every citizen.",
          icon: "icon authing-icon authing-userexperience icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Quick deployment, smooth and non-sense",
          content:
            "The Authing platform is ready to use, and automatically installs and updates. It only takes a few hours to build a new government software based on Authing, or to connect old software to Authing, without repeated programming and provides a software development kit (SDK) and the application interface (API) in 10+ languages.",
          icon: "icon authing-icon authing-Smooth icon-default",
        },
        "item-two": {
          title: "Multiple security, trustworthy",
          content:
            "After conducting a lot of research on data security supervision technology, Authing has improved the monitoring, discovery and processing capabilities for security risks such as illegal cross-border data flows, and adopted global MFA to improve overall security. On the one hand, the login environment is constantly monitored to make all government applications more secure; on the other hand, to increase the usability of users, even if they forget their passwords, fingerprints, SMS, dynamic passwords, face recognition, etc. can be used as authentication factors.",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-three": {
          title: "One software, global monitoring",
          content:
            "Centralized control of user behavior information and portrait information when accessing government services. Through big data technology, it can realize cross-domain and cross-channel comprehensive analysis, explore the people's government needs, and improve the quality and efficiency of government services.",
          icon: "icon authing-icon authing-monitor icon-default",
        },
        "item-four": {
          title: "Collect once, work smoothly",
          content:
            'Users centrally manage personal information and authorize to fill in forms to realize the smooth operation of the "One Number" of the masses, avoid repetitive submission of personal information and service materials to departments and institutions, and realize the diversified collection, intercommunication and sharing of basic user information, and multi-party utilization.',
          icon: "icon authing-icon authing-acquisitionModality icon-default",
        },
      },
      support: {
        title: "How Authing supports the government industry",
      },
    },
    finance: {
      title: "Financial Solution",
      sub:
        "Help financial services companies of all sizes accelerate innovation and improve user experience.",
      challenges: {
        "item-one": {
          title: "User experience not to be ignored",
          content:
            "Consumers with keen eyes have higher and higher standards for user experience. Whether they log in to the user system or purchase financial products, user experience is the foundation of all quality services.",
          icon: "icon authing-icon authing-tiyan icon-style",
        },
        "item-two": {
          title:
            "Cooperation between departments is blocked, and authority management is difficult",
          content:
            "Most financial institutions have many business sectors, each with its own systems and services. This usually leads to a decrease in communication and coordination efficiency between departments, which affects the business efficiency of the company. Multi department management becomes a great challenge for different organizations.",
          icon: "icon authing-icon authing-hinder icon-style",
        },
        "item-three": {
          title:
            "The development is difficult and the security is facing great challenges",
          content:
            "In the financial services industry scenario, the user system, the identity authentication link is complex, the development difficulty is greatly increased, and a large number of sensitive scenarios will be involved. In the security link, there will be a lot of challenges, and the identity link is the top priority. Any error is often fatal.",
          icon: "icon authing-icon authing-kaifa icon-style",
        },
        "item-four": {
          title:
            "There are many employees involved in the system, so it is difficult to manage",
          content:
            "Every financial industry staff needs to involve more than a dozen or even dozens of software tools. Every time an employee enters or leaves the company, he or she has to face the problem of account management. Whether it is processing time or information security, it needs to be improved.",
          icon: "icon authing-icon authing-xitong-2 icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Unforgettable customer experience",
          content:
            "Discerning consumers have a high standard of user experience, whether they log in to check to bank or buy their favorite insurance. User experience has become the cornerstone of many of today's digital transformations, and it all starts with identity. Enable single sign-on to provide a true Omnichannel experience.",
          icon: "icon authing-icon authing-tiyan icon-default",
        },
        "item-two": {
          title: "Help complete digital transformation",
          content:
            "Set identities once and for all to speed up innovation. Authing is designed to connect any employee, supplier, partner and user with any application, ensuring security while improving ease of use, and easily integrating with your existing systems.",
          icon: "icon authing-icon authing-zhuanxingjia icon-default",
        },
        "item-three": {
          title: "Multiple identity sources, click to use",
          content:
            "Fast integration of social login mode, multi identity source. Common third-party login methods, such as WeChat, nail, microblog, etc. In Authing, you just need to click to use it.",
          icon: "icon authing-icon authing-duozhong icon-default",
        },
        "item-four": {
          title: "Trusted enterprise security",
          content:
            "Dynamic token, face recognition, and other MFA functions enable you to have them immediately and use them out of the box, which can comprehensively improve the system access security, guarantee the user transaction security and improve the user experience.",
          icon: "icon authing-icon authing-Safety icon-default",
        },
      },
      support: {
        title: "How Authing supports the finance industry",
      },
    },
    publisher: {
      title: "Publishing Solution",
      sub:
        "Let readers focus on reading, hundreds of millions of users stretch between their fingers, and the distribution, author and editor are under control.",
      challenges: {
        "item-one": {
          title: "Missed growth opportunities",
          content:
            "In the application matrix, different platforms will be developed, and users need multiple accounts to log in to different platforms. As a result, our users will be scattered in various platforms, and even need to conduct mutual drainage among their different products, resulting in missed growth opportunities.",
          icon: "icon authing-icon authing-opportunity-growth icon-style",
        },
        "item-two": {
          title:
            "The development efficiency is low and the cost is wasted seriously",
          content:
            "Product research and development is very slow. Every time we develop an application, we have to develop a user system, and the implementation is complex. Facing different scenarios, we need different capabilities. It is a high waste of time cost and human cost.",
          icon: "icon authing-icon authing-highcost icon-style",
        },
        "item-three": {
          title: "Miscellaneous authority management",
          content:
            "A large number of editors need to edit various categories of books online, which requires complex authority control and approval process.",
          icon: "icon authing-icon authing-tushuguanli icon-style",
        },
        "item-four": {
          title: "Security faces great challenges",
          content:
            "Many users need to purchase and read books online. Security will face great challenges, identity will be the first line of defense, identity authentication user management errors are often fatal.",
          icon: "icon authing-icon authing-Safety icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Give readers a real ultimate experience",
          content:
            "Reading books is a process of nutrition supplements. In the process of nutrition supplements, it is a painful process for students to repeatedly input their passwords. Single Sign-on helps students focus on reading instead of account and password, log in only once, and enjoy all services.",
          icon: "icon authing-icon authing-Smooth icon-default",
        },
        "item-two": {
          title: "Make security trustworthy",
          content:
            "When students buy books in a publishing house, these accounts will also become a cake to attract criminals. Compared with single password authentication, adaptive MFA such as dynamic password and face recognition is a better security upgrade.",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-three": {
          title: "Hundreds of millions of users",
          content:
            "When the peak comes, the login interface will hang up and new users can't register, which will cause a fatal blow to your business. Authing will automatically scale at the peak, contributing to business success.",
          icon: "icon authing-icon authing-user icon-default",
        },
        "item-four": {
          title: "Distribution, author, editor, authority in control",
          content:
            "Publishing House involves many roles, such as topic selection committee, editor, hairstyle, author, etc. each role has different permissions and groups. The RBAC permission control scheme provided by Authing can easily control all roles.",
          icon: "icon authing-icon authing-multiple-roles icon-default",
        },
      },
      support: {
        title: "How Authing supports the publisher industry",
      },
    },
    education: {
      title: "Education Solution",
      sub:
        "Safe and seamless student experience to protect students and faculty, WiFi, campus card and one network access.",
      challenges: {
        "item-one": {
          title: "Campus information security facing challenges frequently",
          content:
            "Schools often suffer from network attacks, and the privacy of students' status information is greatly enhanced. There is endless news of students' information leakage, and the students and their parents who have been leaked are frequently bombarded with junk messages through sales calls.",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        "item-two": {
          title: "Old software costs a lot",
          content:
            "The old software of the school still consumes the maintenance cost, and the school needs to be modernized urgently. In the face of checking scores, online large-scale live conferences, often face server downtime, student parents' login failure, and other peak fluctuations, leading to a significant decline in the sense of experience.",
          icon: "icon authing-icon authing-Consume icon-style",
        },
        "item-three": {
          title: "The demand for authority management is imminent",
          content:
            "The user roles in education scenarios have a long cycle and a large number of changes. They are faced with the challenge of authority control between cycles. Different roles will face multiple authentication scenarios.",
          icon: "icon authing-icon authing-management icon-style",
        },
        "item-four": {
          title: "Difficulties in digital transformation",
          content:
            "It is difficult to have a perfect cross-platform, multi-functional SDK, and API in various languages. Some of them can not even become a unified identity source by themselves. They do not have any business and technical expansibility, which hinders the implementation and deployment of new technologies and applications in the future and makes the school lose its digital foresight and competitiveness. Due to the school's demand for the customized login process and brand UI, most of the unified identity management platforms still rely on consuming huge human resources to do secondary customized development, which can not quickly realize UI configuration.",
          icon: "icon authing-icon authing-zhuanxingjia icon-style",
        },
      },
      values: {
        "item-one": {
          title:
            "Integrate all educational resources to make knowledge accessible",
          content:
            "Libraries, science and technology museums, museums and other digital knowledge are stored in their own systems, and there is a distance from each student. Authing should get through the distance between all digital education resources and students. Let the student through an account, through a screen can obtain any knowledge he needs.",
          icon: "icon authing-icon authing-jiaoyuziyuan icon-default",
        },
        "item-two": {
          title: "7*24，Protect students' information security",
          content:
            "Each functional department of the school contains a large number of sensitive data, so safe operation is very important. Authing constructs an all-round, multi-level, and perfect identity security system, which can ensure data security on the basis of network security. According to the design requirements of infrastructure and various application systems, different security policies and measures are adopted to ensure system security. Authing ensures that each user can and can only access the corresponding information resources and application services through identity authentication, role definition, and permission allocation. It is a user management platform that can be used, checked, and tracked within 7 days * 24 hours to protect students' information security.",
          icon: "icon authing-icon authing-xinxianquan icon-default",
        },
        "item-three": {
          title: "It is easy to operate without maintenance",
          content:
            "Excellent teachers are the most valuable asset of every school. Their enthusiasm, motivation and enthusiasm can inspire and attract students and ultimately make them achieve the most. Authing makes the user management system clear structure, friendly interface, simple operation and no maintenance. Let every teacher put all his energy on the students, no longer troubled by the maintenance system.",
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        "item-four": {
          title: "Everything is set as you wish, not just UI and domain name",
          content:
            "The authing user login component helps developers avoid a lot of implementation details of low-level authentication, including tedious UI development. It is an embedded login form, which can be customized according to the needs of different schools. Provide cross-platform, 10 + language software development kit (SDK) and the application interface (API), can quickly and safely integrate user authentication into various applications.",
          icon: "icon authing-icon authing-sheding icon-default",
        },
      },
      support: {
        title: "How Authing supports the education industry",
      },
    },
    consume: {
      title: "Retail Solutions",
      sub:
        "Promote the process of online and offline integration and help businesses open a new era of retail.",
      challenges: {
        "item-one": {
          title:
            "Business has developed rapidly and internal applications have proliferated",
          content:
            "Internal applications are proliferating. Employees need to remember many accounts and passwords, access different systems, and need multiple authentication. The employee experience is poor.",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        "item-two": {
          title: "Rapid expansion of personnel and complex role management",
          content:
            "It involves regular employees, temporary workers, outsourcers, dealers, supply chain activities and other activities. The addition and deletion management of employee entry and resignation account is complex.",
          icon: "icon authing-icon authing-Consume icon-style",
        },
        "item-three": {
          title: "Authority management is complicated and unclear",
          content:
            "Stores, branches and Flexible Employment Authority management are disorderly, there is no unified access, and it is difficult to apply for authority, trace the source and supervise.",
          icon: "icon authing-icon authing-management icon-style",
        },
        "item-four": {
          title:
            "A large amount of data precipitates, forming an island that is difficult to communicate",
          content:
            "Due to the separation of employee account and data, it is difficult to realize data exchange and unified analysis, and the application of data in management decision-making level is weak.",
          icon: "icon authing-icon authing-zhuanxingjia icon-style",
        },
      },
      values: {
        "item-one": {
          title:
            "Unified identity management for consumers to improve login experience",
          content:
            "The three parties, including WeChat, micro-blog, Alipay, log in, improve the identity management of the consumer membership system, and use the rich social login to achieve user data collection and enhance the consumer login experience.",
          icon: "icon authing-icon authing-jiaoyuziyuan icon-default",
        },
        "item-two": {
          title:
            "Integrate user resources and accurately locate consumer portraits",
          content:
            "Integrate and manage the user resources of the whole supply chain system, multi terminal, multi device and multi social login, get through the member system management, accurately locate the consumer identity portrait, and build intelligent marketing and brand viscosity.",
          icon: "icon authing-icon authing-xinxianquan icon-default",
        },
        "item-three": {
          title: "Hundreds of millions of users, stretching between fingers",
          content:
            "When the peak comes, the login interface hangs up and new users cannot register, which will cause a fatal blow to your business. Authing will automatically scale at the peak, contributing to business success.",
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        "item-four": {
          title: "Enterprise operation and maintenance under control",
          content:
            "When employees join the company or are promoted, they can easily allocate and change the permissions of different applications in the background. Enterprises can also easily cancel and revoke the access permissions of all different platforms when employees leave, protect enterprise data security and save 80% of the workload of operation and maintenance personnel.",
          icon: "icon authing-icon authing-sheding icon-default",
        },
      },
      support: {
        title: "How Authing supports the retail industry",
      },
    },
    enterprise: {
      title: "SaaS Industry Solution",
      sub:
        "Use Authing to increase customer adoption, meet compliance requirements, protect your APIs, and orient your business to the future.",
      challenges: {
        "item-one": {
          title: "Enterprise internal collaboration is in a bottleneck",
          content:
            "The Limited R&D resources focus on their own product development, the enterprise's internal information investment is insufficient, the attention is not enough, and the internal coordination efficiency is low.",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        "item-two": {
          title: "Personnel mobility and rapid expansion",
          content:
            "It involves a variety of colors such as regular employees, flexible employment and upstream and downstream partners. The addition and deletion management of employee entry and resignation accounts is complex, data security and audit are not in compliance, the identity login information between upstream and downstream partners is not interconnected, and registration and login is troublesome.",
          icon: "icon authing-icon authing-Consume icon-style",
        },
        "item-three": {
          title:
            "The number of applications has surged, and there is no unified management",
          content:
            "With the rapid development of business, the proliferation of application tools, the separation of data and identity among applications, the lack of a unified login, authorization and management platform, the low efficiency and high pressure of it operation and maintenance personnel.",
          icon: "icon authing-icon authing-management icon-style",
        },
        "item-four": {
          title: "Weak digital operation capability",
          content:
            "The enterprise service industry is weak in the management of user marketing scenarios. It is difficult to adapt to flexible business scenarios in the design of user identity management, registered user information and unified login entrance of advertising.",
          icon: "icon authing-icon authing-zhuanxingjia icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Increase enterprise income",
          content:
            "Provide potential customers with high-quality products and accelerate the sales cycle through rapid implementation, so as to save valuable engineering development time.",
          icon: "icon authing-icon authing-jiaoyuziyuan icon-default",
        },
        "item-two": {
          title: "Federated single sign on",
          content:
            "Federated SSO authentication is provided by default, giving your users a seamless experience when logging in once and accessing all applications.",
          icon: "icon authing-icon authing-xinxianquan icon-default",
        },
        "item-three": {
          title: "Security and management",
          content:
            "Improve API security and ensure compliance with internal and external partner use cases in a zero trust environment. Authing provides end-to-end API security and management based on an open standards approach.",
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        "item-four": {
          title: "Prevent bad behavior",
          content:
            "Bad actors continue to try to invade enterprises and combine user credentials with additional security layers, making it exponentially more difficult to destroy security. Authing adopts adaptive MFA to effectively prevent these bad behaviors.",
          icon: "icon authing-icon authing-sheding icon-default",
        },
      },
      support: {
        title: "How Authing supports the SaaS industry",
        api: {
          title: "API security",
          subtitle:
            "Improving API security and ensuring compliance with internal and external partner use cases in a zero trust environment can be challenging. Authing provides end-to-end API security and management based on an open standards approach.",
          item1: {
            title: "For users",
            descript:
              "Easily protect and expose your API by supporting all OAuth 2.0 authorization flows and fine-grained scope and permissions, so as to expand the market scope and provide a better user experience.",
          },
          item2: {
            title: "For applications and systems",
            descript:
              "You can easily facilitate secure communication between the API and non interactive external clients and internal APIs with the touch of a switch.",
          },
          item3: {
            title: "For enterprise developers",
            descript:
              "Enable third-party application servers, APIs and system backend to issue authenticated requests to your APIs, while always maintaining control over fine scope and permissions.",
          },
        },
        security: {
          title:
            "Numerous compliance certifications to ensure identity security",
          descript1:
            "There is no doubt that customer data security and compliance are the primary considerations of most companies. Authing has the most advanced security built into the product, so you don't have to worry about the security of your users and business.",
          "descript2-title": "Industry standard agreement: ",
          descript2:
            "Improve the consistency and continuity of business operation and execution by adopting identity platforms that support industry certification standards such as OAuth and openid connect.",
          "descript3-title": "Compliance and certification: ",
          descript3:
            "Authing has a number of domestic and international compliance certifications, including the DJCP Level 3, SOC 2, GDPR, ISO 9001, CCPA, PCI, HIPAA and FERPA, etc., vowing to protect every user & business.",
          "descript4-title": "Public and private clouds: ",
          descript4:
            "Host your application in authoring's public cloud, our private cloud or your AWS environment. Our highly available multi tenant cloud service can handle a large number of transactions every day.",
        },
        mfa: {
          title: "Adaptive MFA",
          subtitle:
            "Adaptive MFA is a simple and effective best security practice method. It can add an additional layer of security protection in addition to the user name and password, and carry out secure authentication without sacrificing the user experience.",
          item1: {
            title: "Protect users from credential theft and fraud",
            descript1:
              "Multi-factor authentication is one of the best ways to prevent account theft. If an attacker wants to invade an MFA protected account, he not only needs to steal credentials, but also needs to verify additional factors.",
            descript2:
              "Generally, we see a tendency to use MFA in industries dealing with sensitive data. There is no additional identity layer in these vertical domains, so the demand for MFA is urgent.",
          },
        },
        sso: {
          title: "Single Sign-On",
          subtitle:
            "Single sign on (SSO) is one of the solutions to integrate enterprise systems. It aims to access all mutually trusted application systems in multiple application systems only by logging in once.",
          item1: {
            title: "One login, easy access to all applications",
            descript1:
              "By virtue of single sign on technology, Authing enables members and customers to access any software services in one place, and uniformly controls identity and permissions. Whether through Enterprise Federation, social login or user name and password authentication, users can log in once and use all applications they are granted access rights.",
            descript2:
              "Authing supports oauth2, oidc, SAML, LDAP and other protocols. Developers can cooperate with the unified user pool and easily realize single sign on with a minimum of five lines of code.",
          },
        },
      },
    },
  },
  // wechat: {
  //   banner: {
  //     title: "Wechat Ecological Solution",
  //     subtitle:
  //       "Authing quickly realize the identity authentication and user management of any web, app and enterprise software, and provide the most perfect login solution for your customers and employees.",
  //   },
  //   "mini-login-scan": {
  //     title: "Scan small login QR code for login",
  //     content:
  //       "This is a pioneering design of Authing. In authing, the scanning small login QR code can be opened to obtain the official real name user information of wechat. The user can complete the registration / login with the real number by one click authorization, thus establishing an account system based on mobile phone number for developers.",
  //   },
  //   "pc-scan-login": {
  //     title: "PC scan login",
  //     content:
  //       "Wechat PC scanning login enables wechat users to use wechat identity to log in to third-party applications or websites safely. After the wechat code scanning login is opened in Authing, wechat users' basic open information can be quickly obtained and basic open functions can be realized.",
  //   },
  //   "web-authorize": {
  //     title: "Wechat website authorization",
  //     content:
  //       "Authing provides a way for users to quickly log in to the website through wechat. If users visit third party web pages in WeChat client, official account can get basic information from WeChat users through the authorization mechanism of WeChat website, and then achieve business logic.",
  //   },
  //   "mini-program-login": {
  //     title: "Login in wechat applet",
  //     content:
  //       "Authing provides developers with a way to quickly obtain user information and complete login through SDK. Through authing's SDK, we can easily obtain the user's identity provided by wechat, and quickly establish an account system based on mobile phone number.",
  //   },
  //   "mobile-login": {
  //     title: "Mobile end pull up wechat login",
  //     content:
  //       "Authing provides a way for developers to quickly jump to wechat login to obtain user information in mobile terminal (IOS or Android) applications. Wechat account access can be completed by simply calling the Authing Mobile SDK.",
  //   },
  //   "mobile-mini-program-login": {
  //     title: "Mobile end pull up applet login",
  //     content:
  //       "The mobile terminal pull up the small program login is the key way to establish the mobile terminal user system with mobile phone number as the center. Authing greatly reduces the development complexity by using SDK. A line of code can obtain the mobile phone number authorized by the user in the applet through the mobile terminal, and establish an account system based on the mobile number.",
  //   },
  // },
  scene: {
    "title-intro": "Scene profile",
    "title-value": "Authing Value",
    "title-support": "How Authing support various scenarios",
  },
  wechat: {
    banner: {
      title: "Wechat Ecological Solution",
      subtitle:
        "Authing quickly realize the identity authentication and user management of any web, app and enterprise software, and provide the most perfect login solution for your customers and employees.",
    },
    intro:
      "When you start to develop an exciting application based on WeChat ecology, How to use the open capabilities of WeChat multi-scenes, how to deal with complex OpenID, UnionID mechanism will be the problem you need to consider. WeChat ecology is very large, there are several scenes（Such as PC website scan code, public account page authorization, applying within the mini program, etc.）,It needs to call a completely different interface. For developers, it will undoubtedly increase understanding and development costs.",
    value:
      "Authing provides a simple, unified SDK for developers at the frontend, and automatically handles the same identity identification, account merge, etc. Based on OpenID,UnionID, and mobile phone numbers in the backend. Developers only need to call the front end SDK without having to worry about the various complex identity logic.",
    type: {
      item1: {
        title: "PC Sign in with WeChat scan code",
        descript:
          "WeChat PC scan code allows users to log in to third-party applications or websites using WeChat identity. After the WeChat scan code is logged in, you can quickly obtain basic open information through Authing and help users implement base openness.",
      },
      item2: {
        title: "PC website uses a small program scan login",
        descript:
          "This is a groundbreaking design of Authing. After the scanning small login QR code is logged in, you can get the official real-name user information of WeChat. You can have a real number to complete the registration or login, and build a mobile phone for developers. Number-based account system.",
      },
      item3: {
        title: "The mobile terminal pulls WeChat login",
        descript:
          "Authing provides developers with a quick jump WeChat login to obtain user information in the mobile (iOS OR Android) app, and the WeChat account access can be completed by simple calling authing mobile SDK.",
      },
      item4: {
        title: "Mobile terminal pulls a mini program login",
        descript:
          "The mobile terminal pulls a mini program to login is a key way to establish a mobile phone number-centered user system. Authing greatly reduces the complexity of the development through SDK, and a line of code can obtain the user in a mini program through the mobile terminal. ",
      },
      item5: {
        title: "WeChat internal web page uses WeChat Authorized Login",
        descript:
          "Authing provides developers with SDK, provides a quick way to get user information in WeChat webpage and complete login. If user accesses a third-party web page in the WeChat client, the public account obtain the basic information of the user through the WeChat webpage authorization mechanism.",
      },
      item6: {
        title: "WeChat mini program login",
        descript:
          "Authing provides developers with SDK, provides a way to get user information in a mini program and complete the login. The user's identity identifier provided by WeChat can be easily obtained through the Authing SDK, quickly establish an account system based on the mobile phone number.",
      },
    },
  },
  idaas: {
    banner: {
      title: "IDaaS has replaced traditional IAM",
      subtitle:
        "With the acceleration of digital transformation and the progress of the cloud,The dimensions and borders of corporate information security are become more and more complex. Identity and access management as the first door to carry extremely critical mission.",
    },
    intro:
      "Traditional IAM is not from the heart in internal employee management and external user management; It is not flexible when new applications and compatible old applications. At the same time, the IdaAs service that came out of the air has replaced the traditional IAM into enterprise infrastructure due to the extension advantage and cross-environment identification and authority management capabilities.",
    value:
      "IDaaS is an abbreviation of Identity As a Service. Contains all functions of traditional IAM and can bring more benefits to companies: enhance marketing and operational efficiency; Accelerate new business online; enhance safety to reduce network attack risks; enhance user experience.",
    type: {
      item1: {
        title: "Operation capacity",
        descript:
          "The traditional IAM account center has weak operational capabilities, difficult to meet large organizations in business, while IDaaS's multi-tenant operation platform and automation workflow (Workflow) can easily enhance corporate operation efficiency.",
      },
      item2: {
        title: "Advocacy and scalability",
        descript:
          "When your number of users continues to rise, the pressure on the user system will continue to increase. The IDaaS of origin cloud can solve this problem, using the Authing IDaaS as an example, with nearly 10 million users per month Authang login enters thousands of systems, with large-scale data processing experience, the digital identity solution built can better support enterprise expansion.",
      },
      item3: {
        title: "Safety improvement",
        descript:
          "Data assets are gradually transcending physical assets to become the most valuable core of enterprises. Theft and attacks for data assets have also been continuously rising. Traditional IAM is built locally, it is difficult to guarantee the safety of enterprises in the hybrid cloud environment, and the permission management has a thickness, and the access control strategy is single.",
      },
    },
  },
  // idaas: {
  //   title: "IDaaS has replaced traditional IAM",
  //   subtitle:
  //     "With the rapid development of digital transformation and cloud computing, the dimensions and boundaries of enterprise information security are becoming more and more complex. As the first door, identity authentication and access rights management are carrying a very critical mission",
  //   navList: {
  //     title1: "IDaaS / IAM definition",
  //     title2: "Operational capability",
  //     title3: "Scalability",
  //     title4: "Security",
  //     title5: "About Authing",
  //   },
  //   explaination: {
  //     overview1:
  //       "With the rapid development of digital transformation and cloud computing, the dimensions and boundaries of enterprise information security are becoming more and more complex. As the first door, identity authentication and access rights management carry a very critical mission.",
  //     overview2:
  //       "In this context, the disadvantages of traditional IAM are gradually exposed: it is difficult to ensure access security in the hybrid cloud environment; it is not competent in the internal staff management and external user management scenarios; it is not flexible enough to launch new applications and compatible with old applications. At the same time, IDaaS service has the advantages of cloud scalability and cross-environment identity recognition and rights management capabilities, replacing the traditional IAM as enterprise infrastructure.",
  //     idaasDefine: {
  //       title: "Definition of IDaaS",
  //       subtitle:
  //         "IDaaS is the abbreviation of identity as a service. It is a managed IAM service built and maintained by a third-party service provider. IDaaS contains all the functions of traditional IAM and can bring more benefits to enterprises",
  //       item1: "Improve marketing and efficiency",
  //       item2: "Accelerate the launch of new business",
  //       item3: "security and reduce network attack risk",
  //       item4: "Enhance user experience",
  //     },
  //     iamDefine: {
  //       title: "Definition of IAM",
  //       imgText: "IAM core functions",
  //       subtitle1:
  //         'IAM is the abbreviation of identity and access management, namely identity authentication and access management. Gartner, a technology consulting firm, defines IAM as "letting the right people access the right resources at the right time and for the right reasons."',
  //       subtitle2:
  //         "Therefore, traditional IAM providers are also known as 4A vendors. They integrate existing systems for enterprises and build an integrated application platform integrating user management, identity authentication, privilege management, and audit.",
  //     },
  //   },
  //   operate: {
  //     title: "Operational capability",
  //     description1:
  //       "For example, it is difficult for IAM to find out the business opportunities of large-scale customers who have not signed in to IAM within six months, and it is difficult for them to find out the business opportunities of customers who have not signed in to IAM in six months and have not been able to meet the needs of their customers.",
  //     description2:
  //       "Similar scenarios are almost everywhere in the daily operation of enterprises, but the traditional IAM does not have such flexible functions. The multi-tenant operation platform and workflow of IDaaS can easily realize such operations, and the efficiency of enterprise operation can be greatly improved.",
  //   },
  //   expend: {
  //     title: "Scalability and scalability",
  //     description1:
  //       "When the number of users is increasing, the pressure on the user system will also increase. The traditional IAM mainly relies on accumulating servers and setting load balancing to optimize, but the number of login failures always increases with the increase of users, which is a disaster for enterprises and users.",
  //     description2:
  //       "The cloud-native architecture of IDaaS can solve this problem well. Take the authentication identity cloud IDaaS for example, nearly ten million users log in to thousands of systems through Authing every month, and have large-scale data processing experience. The digital identity solutions built by third-party IDaaS platforms like Authing can better support enterprise expansion.",
  //     description3:
  //       "Another problem that enterprises often encounter is to continuously access new systems and develop new applications. And every time you go online, you need to get through with the user center to realize single sign-on (SSO), which is a complex task for IAM, and even the vast majority of IDaaS on the market are difficult to support flexibly. The developer-friendly IDaaS like Authing makes it easy for developers to access new applications and be compatible with old applications by encapsulating more than 500 APIs and SDKs in more than 10 languages. Help new businesses go online quickly.",
  //   },
  //   security: {
  //     title: "Security",
  //     description1:
  //       "Data assets are gradually surpassing physical assets and becoming the most valuable core of enterprises. The theft and attacks against data assets are also on the rise. Traditional IAM is built locally, which is difficult to guarantee enterprise security in the hybrid cloud environment. The granularity of privilege management is coarse and the access control policy is single.",
  //     description2:
  //       'For example, when an employee changes his / her common login address or changes his / her frequently used login device, the risk of the member\'s account being stolen will increase. The traditional IAM will take back all his / her permissions in a "one size fits all" way. However, a better way is to double verify the user through other methods such as face or fingerprint. After confirmation, the user is authorized according to the preset policy and authorized in IDaaS In the platform, attribute-based access control (ABAC) allows enterprise IT personnel to configure similar policies easily and flexibly.',
  //     description3:
  //       "The security of third-party cloud services has been questioned, but more and more data show that cloud services have higher security than locally deployed software, and the same is true of IDaaS compared with IAM. The domestic IDaaS platform represented by Authing uses KMS encryption technology to make the managed data only accessible by the owner.",
  //     description4:
  //       "Moreover, Authing also provides private cloud solutions, which enable enterprises to enjoy the advantages of cloud-native products and avoid risks.",
  //   },
  // },

  ad: {
    title: "Move AD to Cloud",
    subtitle:
      "This is why visionary IT organizations want to integrate their old AD environment with modern SSO in Authing. The integration with Authing provides a gateway that can easily and securely connect your employees to many services and resources they want to use",
    navList: {
      agent: "Authing active directory agent",
      function: "AD agent integration functio",
      interval: "Active / Long polling",
      connection: "AD proxy connection",
      management: "AD agent work management",
      integrate: "Use Authing to plan AD integration",
      authentication: "User authentication",
      import: "User import job",
      synchrony: "Real-time synchronization job",
      install: "Install AD agent",
      mix: "Fusion and harmony",
    },
    agent: {
      title: "Authing active directory agent",
      overview1:
        "Active Directory (AD) has been around since 1999 when Microsoft first released it with Windows 2000 Server. Over the years, it has become a key local service for managing identity-based related activities. But as the demand for cloud services and applications has grown, organizations have begun to realize that AD is not built for the cloud-centric world and today's use cases. Nevertheless, they still want a way to leverage their investment in AD and take advantage of modern single sign-on (SSO) to access all their cloud and local applications and resources through a single interface, while reducing management overhead.",
      overview2:
        "This is why visionary IT organizations want to integrate their legacy AD environment with modern SSO in Authing. The integration with Authing provides a gateway that can easily and securely connect your employees to many services and resources they want to use. To help you plan and implement the integration, this article provides you with insights into the functional and operational aspects of the integration from AD to Authing.",
      text1:
        "The Authing AD agent is the core of the integration between AD and Authing. It provides an interface between Authing and the local AD instance. The design of Authing and proxy is extensible in nature, so it is easy to add more users and deploy more proxies as needed. The agent uses secure outbound communication, provides load balancing and job management through long polling, and uses long-term authorization to refresh tokens.",
      text2:
        "You install the agent on a dedicated local member server in the AD domain. Under no circumstances should the agent be installed on the domain controller, because if you need to restart or reinstall the agent, it will affect the domain controller.",
    },
    function: {
      title: "AD agent integration function",
      overview1:
        "The AD agent provides two main functions. The first is delegated authentication, which allows your local AD instance to continue to be the source of authentication. Through delegated authentication, all passwords are kept in AD, and AD determines whether users can access Authing.",
      overview2:
        "Every time a user tries to access a resource through Authing, Authing will route those authentication attempts to the local AD directory. After authentication, AD allows Authing to grant users access to Authing and assigned resources.",
      text1:
        "The second main function of the agent is to import users and groups with relevant attributes from AD to Authing. The import process creates a new user object in Authing for each user object that exists in the AD organizational unit (OU) you specify.",
      text2:
        "Authing then links the respective AD and Authing users together. This allows Authing to manipulate and enhance user attributes of objects stored in its universal login as needed, without affecting user objects stored in AD.",
      text3:
        "You can also bring your users to Authing, which allows you to take advantage of Authing’s feature set, such as providing centralized SSO for any resources your users need, whether they reside on-premises or in the cloud.",
    },
    internal: {
      title: "Active / Long polling",
      overview1:
        "Authing deploys the AD agent in an active/active configuration without a primary agent or secondary agent. Therefore, there is no need to actively load balance the agents. All deployed agents are always active and use long polling to continuously find new jobs as their ability to handle these jobs allows.",
      overview2:
        "Therefore, using our long polling model, Authing no longer waits for requests from the agent as in the traditional client-server relationship but continues to push jobs to the job pool, and the agent gets them as soon as possible. Since the job is almost immediately taken away, compared with the traditional model, the waiting time can be saved and the job can be processed faster.",
      "img-text-interval": "Active / Long polling",
      "img-text-connection": "AD proxy connection",
    },
    connection: {
      title: "AD proxy connection",
      overview:
        "The Authing AD proxy uses certificate pinning with TLS server authentication to create an outbound HTTPS connection to the Authing identity cloud. Each connection lasts no more than 30 seconds. During this connection time, the AD agent will listen to events from the Authing service that it can handle, such as AD authentication events. If such an event occurs, the AD agent will catch it for processing and close the connection. Then, the AD agent will immediately open a new connection and listen for new jobs again. If no event occurs during the 30-second window of the connection, the agent will close the connection and start a new 30-second connection to listen for another job.",
    },
    management: {
      title: "AD agent work management",
      overview1:
        "Since authentication jobs are usually small jobs that need to be processed quickly, and import jobs are large jobs that take more time, Authing uses different workload distribution methods for each job type. Authing can better adapt to inherent differences in work types. Any available agent can handle authentication tasks. Therefore, Authing randomly selects an agent from the pool of available agents for each authentication task.",
      overview2:
        "The import job uses the preferred proxy. Although the initial agent assignment is random, Authing will continue to use the agent to perform subsequent tasks until the agent becomes overwhelmed or unavailable. At that time, Authing will assign other agents to handle import tasks.",
      overview3:
        "By default, Authing configures each agent with two threads. However, if necessary, you can configure up to 10 threads for the agent to solve the agent's needs. Generally, there is always a thread in the agent that can be used to handle authentication tasks. For example, when an agent gets a publish import job, Authing will not send any other import jobs to the agent before the job is completed, but the agent's second thread can still be used to accept authentication jobs.",
      block1: {
        title: "Example authentication job",
        item1: "The job thread remains open for 30 seconds",
        item2: "The agent executes HTTP GET to get the job from Authing",
        item3: "The proxy receives the authentication job from Authing",
        item4: "The agent performs authentication operations",
      },
      block2: {
        title: "Example of an import job being performed",
        item1: "The job thread remains open for 30 seconds",
        item2: "The agent executes HTTP GET to get the job from Authing",
        item3: "The agent receives the import job from Authing",
        item4: "Agent performs import operations",
        item5: "Agent becomes the preferred agent for import jobs",
      },
    },
    integrate: {
      title: "Use Authing to plan AD integration",
      overview:
        "When planning and establishing integration, it is important to understand the difference between user authentication capabilities and user import. For example, the frequency of these job types and their user groups have different effects on the operability of your AD integration with Authing. Similarly, the importance of knowing when the user base performs each type of job is as important as understanding the size of the user base, or even more important. To help you with integration planning and construction work, the following content provides some additional details for each job type, including the differences in how each job type works.",
    },
    authentication: {
      title: "User authentication",
      overview1:
        "When users enter their credentials in the Authing user interface for authentication, Authing will determine whether they are the primary AD user. If they are AD master users, Authing will add their authentication request to the job list associated with the user's directory instance. After adding the authentication job to the job list, Authing will randomly assign the job to any available AD agent polling job, and then the assigned agent will open the job on the server running the agent. AD master user refers to the user whose original attribute is owned by the AD instance.",
      overview2:
        "Next, the AD agent uses the user name format specified in the AD integration settings (for example, user principal name (UPN)) to look up the user. After the agent finds the user, it will perform BIND on the AD instance using the credentials entered by the user. The following is an example of a UPN query that the agent can use to find a user:",
      overview3:
        "Compared with user import, user authentication can be performed quickly. After completing the integration settings, the agent can begin to perform a lot of authentication. As needed, you can deploy multiple other agents in the integration to allocate more resources for authentication.",
      overview4:
        "One of the reasons for deploying other agents for authentication may be to better handle seasonal trends. For example, retail stores often experience large upward fluctuations during the holidays. The need for high availability is another reason why organizations often deploy other agents for authentication.",
      overview5:
        "Besides, global organizations often deploy other AD agents in locations close to their different geographic locations. Deploying AD agents on member servers that are very close to the domain controller or domain controller pool can reduce the delay during authentication. As mentioned earlier, it is important to ensure that the AD agent is deployed only on dedicated member servers and not on domain controllers.",
    },
    import: {
      title: "User import job",
      overview1:
        "User import can be initiated by scheduled import or manual import. Both methods create a job in Authing and assign the job to the preferred agent. Like the authentication job, the AD agent will contact Authing, pull down the job, open it on the local server running the agent, and execute the job. The agent first performs topology reading of the entire AD structure. The agent will then update users and groups. If it is an incremental import, it will perform the import based on the usnChanged AD attribute value read for each object. *The range of objects read will be based on the import settings of the AD agent. The content configured in the AD integration settings of the Authing tenant.",
      tip: "The following is an example of an import job query:",
      overview2:
        "It is important to remember that once the server has run the import, it will become the preferred import server. This means that subsequent import jobs will be sent to the same server. Therefore, if the AD agent is deployed on multiple servers, the import job will not be scattered on all these servers. Instead, they will only be executed on the current preferred server.",
      overview3:
        "In addition, it is important to understand that the import speed depends on the size of the catalog, the scope, and frequency of the import. For example, if the import scope includes 10,000 OUs and millions of users have been updated since the last import, the import scope will take longer than importing 5,000 OUs and users who have not yet been updated.",
      warn:
        "Note: For more information about the usnChanged attribute of Microsoft AD, please visit",
      code: {
        read: "Topological reading",
        account: "User account read",
      },
    },
    synchrony: {
      title: "Real-time synchronization job",
      overview1:
        "In addition to user authentication and user import, if just-in-time (JIT) updates are enabled, the Authing AD agent will also perform real-time synchronization tasks. The real-time synchronization job will update user attributes, group memberships, and create new groups in Authing upon login. To this end, the agent performs BIND on a randomly selected AD server.",
      overview2:
        "After a successful BIND, the server will receive a security token containing a list of group security identifiers (SIDs) to which the current user belongs. The proxy extracts the SID from this token, uses the SID to find the group in its local SID cache, and then sends membership to Authing so that Authing can add the user to the group. If SIDs do not exist in the local cache, the agent will search for them in AD.",
    },
    install: {
      title: "Install and troubleshoot the AD agent",
      overview1:
        "You can find detailed requirements, procedures, and tasks for installing the AD agent into the AD agent integrated with Authing in Authing.cn/docs. To help you troubleshoot, Authing records the Windows Event Viewer operations performed by the AD agent in the AD agent's log. AD agent logs are stored in",
      overview2:
        "And Windows Event Viewer. If you need additional logging information, you can enable detailed logging.",
      overview3:
        "Since the AD proxy communicates with Authing via HTTPS, you can use a web monitoring tool (such as Fiddler) to capture this traffic.",
    },
    mix: {
      title: "Fusion and harmony",
      overview1:
        "By integrating AD and Authing with the Authing AD proxy, you can take full advantage of modern applications, including mobile applications, SaaS applications, and local applications. By adding these applications to Authing, you can automatically provide access to your AD users. Authing can also easily protect access to these applications through a set of central policies, adaptive MFA, and even the option of no password. By using our Authing RADIUS proxy and Authing LDAP interface, you can even extend some of the security functions of Authing to local network devices, such as Wi-Fi routers, VPNs, and other network devices.",
      overview2:
        "With centralized identity access management (IAM) and a single login interface, users can access all the applications and services they need, which significantly reduces management overhead, speeds up application deployment, and provides users with more seamless and consistent access rights, and Enhance overall security with more modern identity verification functions.",
      overview3:
        "In the past, AD has become an integral part of your environment and will continue to provide value in the future. However, as you leverage the many advantages of the modern IAM that Authing brings with this integration, the way you view AD roles may change. Authing opens a gateway to easily and securely access the ever-growing modern applications and services. Utilizing our vendor-agnostic nature and integrated network, you can connect to any technology through Authing to provide you with the flexibility you need to drive business innovation and success.",
    },
  },
  buildIdaas: {
    banner: {
      title: "Build exclusive identity clouds, help corporate development",
      subtitle: `As companies have gradually accelerated digital transformation, "identity and access management" is critical to the success of the business. The perfect identity and access management solution can determine the success or failure of the digital transformation plan.`,
    },
    intro: {
      descript1: `For companies competing in "Borderless and Digital World", the protection sensitive system and customer confidential data are critical. However, the current network security situation is not optimistic. When customer data is abused or stealing due to improper importance, companies will not only suffer business losses, but also facilitate huge compliance fines and other legal penalties.`,
      descript2:
        "According to the data in 2016-2019, China's IT expenditure accounts for the world's proportion and GDP, the degree of digitalization in Chinese companies is in high-speed growth. When the company has gradually recovered from the 2020 global epidemic situation, they will also face a large number of IT project backlogs, however, funds used to complete these projects are limited.",
      descript3:
        "Therefore, building identity cloud IDaaS will help companies achieve digital transformations faster, reduce financial burden, and effectively avoid the development of manufacturing disorders to increase unnecessary costs.",
    },
    features: {
      title:
        "Authing has helped 20000+ companies and developers to build standardized user identity systems",
      item1: {
        title: "Perfect identity service",
        descript:
          "The traditional IAM account center has weak operational capabilities, difficult to meet large organizations in business, while iDaAS's multi-tenant operation platform and automation workflow (Workflow) can easily enhance corporate operation efficiency.",
      },
      item2: {
        title: "Reduce corporate development costs",
        descript:
          "Subscribe Authing will save the cost of building an identity management system and mitigate the burden of future repairs upgrades. The liberated human material can let the development team focus on the core business, develop new growth space for the innovation capacity of the company, but also speed up the delivery of products.",
      },
      item3: {
        title: "Improve operational management efficiency",
        descript: `The interior of large enterprises and organizations will usually be divided according to dimensions such as "Region", "Department", and different services often need to ensure independence, Authing Identity Cloud Utilize multi-tenant technology to help companies solve the problem of business and data.`,
      },
      item4: {
        title: "Improve identity safety",
        descript:
          "Dynamic tokens, face recognition, etc. MFA function, comprehensively improve system access security and ensure user access security.",
      },
      item5: {
        title: "Improve system scalability",
        descript:
          "Once you purchase an identity management API development kit, the development team can integrate the application you need on the platform, no need to repeat the construction, purchase identity management plan, and is very friendly to developers.",
      },
    },
    list: {
      title:
        "List of features required to be included in standard identity cloud",
      subtitle:
        "The following is a list of functions that a standard identity cloud IDaaS needs to include. Of course, each enterprise has its own unique organizational form and business model.",
      table: {
        firstHead: "Primary function",
        secondHead: "Secondary function",
        thirdHead: "Explain",
        item1: {
          title: "Unified account",
          content: {
            subtitle1: "User management",
            descriptions1: {
              description1: "User batch import and export",
              description2:
                "Add / delete / modify / check the user account number item by item / batch",
              description3:
                "User attribute management (basic field + user defined field)",
              description4:
                "User status management (enable / unlock / disable / activate, etc.)",
              description5: "User password reset",
            },
            subtitle2: "Organization and management",
            descriptions2: {
              description1: "Multi level organization structure tree",
              description2: "Organization and management",
            },
            subtitle3: "User group management",
            descriptions3: {
              description1: "User group creation / query / deletion, etc",
              description2: "User group attribute management",
            },
            subtitle4: "Directory synchronization",
            descriptions4: {
              description1:
                "Account synchronization (upstream synchronization)",
            },
          },
        },
        item2: {
          title: "Unified certification",
          content: {
            subtitle1: "Authentication source management",
            descriptions1: {
              description1:
                "It supports authentication source configuration, supports adding enterprise wechat, ad authentication source and LDAP authentication source; supports user-defined authentication source, including authentication source based on openid, SAML and CAS protocol.",
            },
            subtitle2: "Authentication method",
            descriptions2: {
              description1:
                "Support Adaptive MFA, including account name / password, OTP, QR code, social login authentication, etc",
            },
            subtitle3: "Authentication configuration",
            descriptions3: {
              description1:
                "Support different authentication factors for different applications",
            },
          },
        },
        item3: {
          title: "Unified application",
          content: {
            subtitle1: "Application management",
            descriptions1: {
              description1:
                "Support application pre integration; support the creation of custom applications (openid connect, formpost, SAML2.0, CAS, oidc and other standard protocols)",
            },
            subtitle2: "Single sign on",
            descriptions2: {
              description1: "Support the configuration of SSO for applications",
            },
            subtitle3: "Account number supply",
            descriptions3: {
              description1:
                "Support the synchronization of accounts, institutions, etc. to the application system",
            },
            subtitle4: "SaaS service access capability",
            descriptions4: {
              description1:
                "Supports integration of third-party SaaS or enterprise self-built applications through OIDC, SAML, CAS, LDAP, AD and other standard protocols",
            },
            subtitle5: "Tenant-level app access",
            descriptions5: {
              description1:
                "Support access to different applications according to different tenants of IDaaS identity cloud;",
            },
            subtitle6: "Workbench integration",
            descriptions6: {
              description1:
                "Support enterprise wechat workbench; support adding workbench",
            },
          },
        },
        item4: {
          title: "Unified authority",
          content: {
            subtitle1: "Authority management",
            descriptions1: {
              description1:
                "It supports application level authorization and RBAC based authorization",
            },
            subtitle2: "Permission configuration",
            descriptions2: {
              description1:
                "Support authorization based on user / user group / organization",
            },
            subtitle3: "Permission synchronization",
            descriptions3: {
              description1:
                "Support the synchronization of application permissions",
            },
          },
        },
        item5: {
          title: "Unified audit",
          content: {
            subtitle1: "User action log",
            descriptions1: {
              description1:
                "Support the query and export of user operation log",
            },
            subtitle2: "Administrator operation log",
            descriptions2: {
              description1:
                "Support query and export of administrator operation log",
            },
          },
        },
        item6: {
          title: "Security management",
          content: {
            subtitle1: "Administrator configuration",
            descriptions1: {
              description1:
                "It supports the creation and deletion of administrators / administrator groups, and supports the configuration of different administrator roles",
            },
            subtitle2: "Security policy",
            descriptions2: {
              description1:
                "Support password policy configuration, including password strength settings, password reset settings, login security settings, etc",
            },
          },
        },
        item7: {
          title: "Application access capability",
          content: {
            subtitle1: "SaaS service access capability",
            subtitle2: "Tenant level application access capability",
          },
        },
        item8: {
          title: "Operation and maintenance & operation management capability",
          content: {
            subtitle1: "IDaaS tenant operation platform",
            descriptions1: {
              description1:
                "The enterprise operation center supports centralized management of all tenants, applications, orders, etc. in the identity cloud; core data visualization",
            },
            subtitle2: "IDaaS operation & maintenance platform",
            descriptions2: {
              description1:
                "One-click deployment belongs to the IDaaS platform, and system operation and maintenance, data monitoring, and service upgrades are all under control",
            },
          },
        },
      },
    },
  },
  cognito: {
    banner: {
      title: "Move from AWS Cognito",
      subtitle:
        "Authing can solve many problems in using Cognito. Using the Authing user pool can completely replace Cognito user pool and build a bridge between domestic users and AWS resources.",
    },
    intro: {
      descript1:
        "During Web or App Development, users' authentication and permission processing are a very important module, including user registration, login authentication, and management corresponding permissions. In addition to the username password login, it is also very important to log in through third-party social account. It is mainly Google, Facebook or Apple Login, etc., which is mainly WeChat, Weibo login, etc.",
      descript2:
        "Identity authentication and authorization implementation are complicated, so the Cognito service is provided on the AWS cloud to help developers are faster and safer to access user registration / login and access control functions. The Cognito service allows companies to spend more energy on the core business, pay attention to innovation, income, not too much attention to identity authentication and authorization-related underlying technical details.",
    },
    value: {
      title:
        "AWS Cognito User Pool Service is not online in the domestic area, for companies who want to use Cognito IDaaS services in China, Authing will be better. Authing can solve many problems using Cognito, Using Authing User Pool, you can fully replace Cognito User Pool to build a bridge between domestic users and AWS resources.",
      item1: {
        title: "Architecture design",
        subtitle: "Demonstrate the overall structure of the website",
        list1:
          "The static website is hosted by S3, and the static content acceleration and the HTTPS certificate mount are carried out by CloudFront.",
        list2:
          "Using Authing to authenticate the login and obtain the token, as an alternative to the user pool.",
        list3: "Access the Rest API provided by API Gateway.",
        list4:
          "Obtain temporary AWS credentials through Cognito Identity Pool to access AWS resources (here, take Polly service as an example).",
        tip:
          "At present, the demo website has been deployed in the domestic area of AWS",
        link: "View visit effect",
        img:
          "//files.authing.co/authing-website/solution-cognito-framework-design-en.svg",
      },
      item2: {
        title: "Login authentication and get token by Authing",
        subtitle:
          "Authing authenticates the user based on OIDC and OAuth 2.0 and grants the user access to the corresponding application.",
        list1:
          "The user requests to log in through the Authing user pool and gets the code from the server after successful authentication.",
        list2:
          "The application requests token with code through the identity pool.",
        list3:
          "Users can use token to request access to various application resources.",
        imgText:
          "The above figure describes the OIDC Authorization Code Flow to obtain Token. Users can also obtain token through OIDC Implicit Flow. This example uses Implicit Flow, ",
        link: "View comparison.",
        img:
          "//files.authing.co/authing-website/solution-cognito-login-token-en.svg",
      },
      item3: {
        title: "Access the protected REST API provided by API Gateway",
        subtitle:
          "The token (i.e. id_token) can be obtained after login and authentication through Authing. You can access the protected REST API by carrying a token in the header when sending an HTTP request.",
        img:
          "//files.authing.co/authing-website/solution-cognito-identity-pool-en.svg",
      },
      item4: {
        title:
          "Secure access to AWS services through integration with Identity Pool",
        subtitle:
          "The token (i.e. id_token) can be obtained after login and authentication through Authing. Through the integration with identity pool, temporary credentials can be obtained to access AWS resources safely.",
        img:
          "//files.authing.co/authing-website/solution-cognito-api-gateway-en.svg",
      },
    },
  },
  // cognito: {
  //   title: "Move from AWS Cognito",
  //   subtitle:
  //     "Authing can solve many problems in using Cognito. Using the Authing user pool can completely replace Cognito user pool and build a bridge between domestic users and AWS resources.",
  //   extra: "* Content from the official AWS blog",
  //   intro: {
  //     title: "Introduction to AWS Cognito",
  //     descript1:
  //       "In the process of web or app development, user authentication and authority processing is a very important module, including user registration, login authentication, and management of corresponding permissions. In addition to user name and password login, it is also a very important demand to log in through a third-party social account. In foreign countries, it is mainly Google, Facebook, or apple login, while in China, it is mainly WeChat and microblog login.",
  //     descript2:
  //       "Identity authentication and authorization are complex to implement. Therefore, Cognito service is provided on the AWS cloud to help developers access user registration/login and access control functions faster and more safely. Cognito service allows enterprises to focus more on their core business, focusing on innovation and revenue generation, rather than paying too much attention to the underlying technical details related to authentication and authorization.",
  //   },
  //   project: {
  //     title: "Alternatives",
  //     item1: {
  //       title: "Architecture design",
  //       subtitle: "Demonstrate the overall structure of the website",
  //       list1:
  //         "The static website is hosted by S3, and the static content acceleration and the HTTPS certificate mount are carried out by CloudFront.",
  //       list2:
  //         "Using Authing to authenticate the login and obtain the token, as an alternative to the user pool.",
  //       list3: "Access the Rest API provided by API Gateway.",
  //       list4:
  //         "Obtain temporary AWS credentials through Cognito Identity Pool to access AWS resources (here, take Polly service as an example).",
  //       tip:
  //         "At present, the demo website has been deployed in the domestic area of AWS",
  //       link: "View visit effect",
  //     },
  //     item2: {
  //       title: "Login authentication and get token by Authing",
  //       subtitle:
  //         "Authing authenticates the user based on OIDC and OAuth 2.0 and grants the user access to the corresponding application.",
  //       list1:
  //         "The user requests to log in through the Authing user pool and gets the code from the server after successful authentication.",
  //       list2:
  //         "The application requests token with code through the identity pool.",
  //       list3:
  //         "Users can use token to request access to various application resources.",
  //       imgText:
  //         "The above figure describes the OIDC Authorization Code Flow to obtain Token. Users can also obtain token through OIDC Implicit Flow. This example uses Implicit Flow, ",
  //       link: "View comparison.",
  //     },
  //     item3: {
  //       title: "Access the protected REST API provided by API Gateway",
  //       subtitle:
  //         "The token (i.e. id_token) can be obtained after login and authentication through Authing. You can access the protected REST API by carrying a token in the header when sending an HTTP request.",
  //     },
  //     item4: {
  //       title:
  //         "Secure access to AWS services through integration with Identity Pool",
  //       subtitle:
  //         "The token (i.e. id_token) can be obtained after login and authentication through Authing. Through the integration with identity pool, temporary credentials can be obtained to access AWS resources safely.",
  //     },
  //   },
  //   replace: {
  //     title: "Replace AWS Cognito with Authing",
  //     item1: {
  //       title: "Pain point",
  //       subtitle:
  //         "Although AWS is the world's largest cloud computing provider, Cognito services are not available on the Chinese mainland. For enterprises that want to use the IDaaS services such as Cognito, Authing is the best alternative to Cognito.",
  //     },
  //     item2: {
  //       title: "The value of Authing",
  //       subtitle:
  //         "Authing can solve many problems in using Cognito. Using the Authing user pool can completely replace Cognito user pool and build a bridge between domestic users and AWS resources.",
  //     },
  //   },
  //   deploy: {
  //     title: "Scheme deployment",
  //     subtitle1:
  //       "Both the front-end and back-end code of the demo site have been published in the Github:",
  //     subtitle2:
  //       "you can refer to the relevant code for deployment and testing.",
  //     item1: {
  //       title: "Authing account opening and OIDC application configuration",
  //       subtitle1:
  //         "First of all, you need to create an OIDC application in Authing. For details, please refer to the ",
  //       subtitle2:
  //         ".The demo environment uses implicit flow and rs256 algorithm for id_token signature. Refer to the left figure for callback URL, authorization mode and return type settings.",
  //       imgText: "Callback URL, authorization mode, return type, etc",
  //       link: "View document",
  //     },
  //     item2: {
  //       title: "Deploying API gateway and lambda through Sam",
  //       subtitle1:
  //         "Since the id_token is encrypted by rs256 algorithm, the corresponding key needs to be set in lambda authorizer for token verification. For details, please refer to the example code app.js Related notes in ",
  //       subtitle2:
  //         "In the demonstration environment, API Gateway and related lambda have been described in an AWS Sam template, which can be deployed automatically through Sam.",
  //       link: "View document",
  //     },
  //     item3: {
  //       title: "Configuration of integrating Authing and Identity Pool",
  //       subtitle:
  //         "At the same time, Cognito Identity Pool will create two Iam roles (for authenticated users and anonymous users). You need to set the permissions for the IAM Role of the authenticated user. The sample website uses Polly service, so you need to add the permission to access Polly.",
  //       config: "Config",
  //       configTip: "Config OIDC Provider",
  //       provider: "Provider URL",
  //       providerTip:
  //         "It is the corresponding issuer of the Authing application",
  //       audience: "Audience",
  //       audienceTip:
  //         "This is the app ID corresponding to the Authing application",
  //       doc: "Reference documents",
  //       docTip:
  //         "Please refer to relevant official documents of AWS for specific configuration ",
  //       configIdentity: "Config",
  //       configIdentityTip: "Config Cognito Identity Pool",
  //       authenticated: "Authenticated Provider",
  //       authenticatedTip: "Specify Authing as Authenticated Provider",
  //       imgText: "Create success examples",
  //       demoLink: "View demo",
  //       docLink: "View document",
  //     },
  //     item4: {
  //       title: "Deploy static website as front end demo",
  //       subtitleTitle: "Front end demo page:",
  //       subtitle:
  //         "It can be uploaded to the S3 bucket and enable the S3 static website hosting function. Note that CloudFront and HTTPS certificate should be added in the front, or you can choose to deploy on an EC2.",
  //     },
  //   },
  // },

  keycloak: {
    banner: {
      title: "Move from Keycloak",
      description: `Compared to Keycloak, Authing is more convenient, secure and compliant for enterprises and developers with its ready-to-use solution.`,
      solution: "下载解决方案",
      consult: "方案咨询",
    },
    replace: {
      title: "Why choose Authing over Keycloak ?",
      subtitle:
        "Based on open-source IDaaS, there are high security risks, and significant technical costs.",
      authing: {
        title: "Using Authing",
        subtitle: "Enjoy a ready-to-use identity IDaaS product",
        item1: {
          title: "Qualified data security",
          descript:
            "Authing has comprehensive security protection strategies that can be set according to enterprise needs. It also has security certifications such as ISO, Level 3 Protection, GDPR, etc.",
        },
        item2: {
          title: "Low development cost",
          descript:
            "Authing provides multiple functions like SSO, authentication, access management etc, along with comprehensive technical documentation, which can significantly shorten enterprise development time.",
        },
        item3: {
          title: "Easy operation and maintenance",
          descript:
            "Authing frequently upgrades functions and patches vulnerabilities, without requiring enterprises to maintain them, and it has rich implementation experience for enterprises.",
        },
        item4: {
          title: "Active customer service",
          descript:
            "For enterprise, Authing provides exclusive customer success managers who can respond within 20 minutes. For individual developers, there is also a comprehensive developer forum.",
        },
      },
      keycloak: {
        title: "Using Keycloak",
        subtitle: "Face the hidden defects of open-source IDaaS",
        item1: {
          title: "Unstandardized data security",
          descript:
            "The code of open-source software can be accessed directly by hackers, and it is difficult to meet China's strict security compliance requirements and to customize suitable security policies.",
        },
        item2: {
          title: "High R&D costs",
          descript:
            "Open-source software is not entirely free. Enterprises still need to invest a significant amount of technical costs to develop an identity system to ensure it meets business needs.",
        },
        item3: {
          title: "Difficult operation and maintenance",
          descript:
            "The way open-source software fixes bugs can easily cause structural problems in the source code, making it difficult for enterprises to maintain and hard to find reliable solutions quickly.",
        },
        item4: {
          title: "Limited after-sales service",
          descript:
            "Keycloak is a free open-source project with no fixed developer support or responsive customer success service. In the event of urgent problems, there is a lack of security and efficiency guarantees.",
        },
      },
    },
    marquee: {
      item1: {
        title1: "A globally online education platform",
        desc1:
          "This platform serves 78M users in 180 countries, offering courses & teaching opportunities",
        title2: "Reduce costs and quickly launch",
        desc2:
          "We planned to develop our own identity system based on Keycloak, but it was not feasible due to the timeline and compliance requirements. So, we opted for Authing. The development was completed in two weeks, laying a solid foundation for our business expansion.",
      },
      item2: {
        title1: "A top fund service provider",
        desc1:
          "An innovative fintech company that specializes in the asset management industry",
        title2: "Reduce costs and easily manage",
        desc2:
          "With the rapid expansion of our business, the original Keycloak solution and manual maintenance method were unable to meet our needs. After migrating to Authing, we greatly reduce our maintenance costs, and effectively enhance security.",
      },
    },
    table: {
      title: "Rapidly launch a complete identity system with Authing",
      description:
        "Compared with Keycloak, Authing has more complete support and richer construction experience, which can truly help enterprises improve the ROI.",
      fun: "Function",
      fun1: "Default Support for Authentication Protocols",
      fun2: "Identity Verification for Web and Mobile App",
      fun3: "Custom Database Connection",
      fun4: "Fine-grained Access Control",
      fun5: "Login Form Components",
      fun6: "Dynamic Adaptive MFA",
      fun7: "Audit Logs",
      fun8: "Multiple SDK Support",
      fun9: "Custom User Data",
      fun10: "Real-time Password Leak Detection",
      fun11: "Webhooks and Events",
      fun12: "Multi-tenant Applications Support",
      fun13: "International Language Support",
      fun14: "Strong Data Isolation",
      fun15: "Custom Password Encryption Algorithms",
      fun16: "License and Compliance Management",
      fun17: "Brute Force Detection",
      fun18: "Custom Social Login Connection",
      keycloak: "Currently, only OIDC and SAML 2.0 are supported",
      authing: "OAuth 2.0, OIDC, SAML, AD/LDAP, etc",
    },
  },
  mfa: {
    banner: {
      title: "Adaptive MFA",
      subtitle:
        "After enabling adaptive MFA, users need to provide not only the user name and password (the first authentication), but also the verification code (the second authentication). The combination of MFA will provide higher security protection for your account and resources.",
    },
    challenge: {
      title: "Challenges facing modern enterprises and organizations",
      subtitle: `The rapid development of big data, the Internet, and 5G, while bringing unlimited development opportunities to mankind, has also spawned a large number of information leakage incidents. According to the "IBM 2020 Data Breach Report", the average total cost of a data breach is 3.86 million U.S. dollars (approximately RMB 25.21 million)`,
      description1:
        "For companies, the cost of data breaches is getting worse. On the one hand, companies will be punished by regulators. For example, British Airways was fined 204 million euros by the Office of the Information Commissioner (ICO) for data breaches. On the other hand, once a data leak occurs, it will not only make the company lose the trust of customers and users, but also affect the company's long-term development.",
      description2:
        "Therefore, the use of MFA (hereinafter collectively referred to as MFA) has become a basic means for enterprises to prevent data leakage. MFA requires users to use at least two factors to verify their identity, and only after passing the verification can they access applications, which is rapidly spreading among enterprises.",
      description3:
        "At the end of last year, LastPass conducted a survey of 47,000 companies and found that 57% of companies worldwide are currently using MFA, an increase of 12% over the previous year. Statistics also prove the effectiveness of MFA. Earlier this year, Microsoft reported that 99.9% of the illegal accounts it tracks did not use MFA.",
    },
    features: {
      title: "Authing Adaptive MFA core function",
      item1:
        "Authing guarantees business security through multiple authentication methods",
      item2:
        "Customized authentication process, one-key open, simple operation",
      item3:
        "Support equipment environmental data reporting, multi-dimensional analysis of security levels",
      item4:
        "Support configuration strategy to achieve environmental risk adaptation",
      item5: "Also suitable for in-app permission control scenarios",
      item6: "Integrated into the universal login component (Guard) by default",
      item7: "User data management, behavior log query",
      item8:
        "Provide SDK and open interfaces to help developers quickly call-related capabilities and build custom user management pages",
    },
    mode: {
      title:
        "Multiple authentication methods to improve corporate identity security",
      item1: {
        title: "Mobile token",
        list1:
          "With strong dynamic OTP password verification, it helps protect account security and avoid malicious attacks.",
      },
      item2: {
        title: "SMS/email verification code",
        list1: "Easy to use",
        list2: "Convenient",
        list3: "Improve login security",
      },
      item3: {
        title: "Compatible with third-party authenticators",
        list1: "Compatible with third-party authenticators",
        list2:
          "To avoid the pain of not being able to receive verification text messages, it can be used without an internet connection, and the phone outage will not be affected.",
      },
      item4: {
        title: "Biometrics",
        list1:
          "Fingerprint/face, as a key factor of human body characteristics, is widely used in the field of security authentication.",
        list2:
          "High security, high precision, authentication can be completed without entering a password.",
      },
      item5: {
        title: "Graphic lock",
        list1: "Simple and easy to use",
        list2: "Security can be enhanced with more complex graphics",
      },
      item6: {
        title: "Mini Program Certification",
        list1:
          "Integrate the Authing mobile token validator into the WeChat applet, eliminating the need to install the app, and quickly use the mobile validator.",
      },
    },
    advantage: {
      title: "Advantages of Authing MFA",
      subtitle:
        "Empower Authing applications to quickly enable MFA, and immediately improve application authentication and access security levels",
      item1: {
        title: "Developer friendly",
        subtitle:
          "Provides an out-of-the-box client SDK to facilitate client developers to quickly implement MFA",
        list1: "· Support multiple terminals: Web, iOS, Android",
        list2:
          "· Built-in multiple MFA terminal components, such as OTP, verification code, fingerprint unlock, facial recognition, graphic lock, etc.",
        list3:
          "· Only need to call a method to evoke the MFA certification component, get the certification result, and complete the certification process",
      },

      item2: {
        title: "Custom data reporting",
        subtitle:
          "Customized data reporting, participating in the process to initiate decision-making, covering more complex and refined scenarios",
        list1: "· Support data reporting during Authing SDK initialization",
        list2: "· Support timing data reporting",
        list3: "· Support active data reporting during application runtime",
      },
      item3: {
        title: "Strategy-based",
        subtitle:
          "The trigger conditions for MFA are based on custom strategies, and the strategy system is simple, efficient, complete and flexible",
        list1:
          "· Simple: you don’t want to configure a complicated strategy, you can use the default security strategy or preset hit conditions",
        list2:
          "· Efficient: Millisecond level judgment strategy hits, MFA is immediately aroused; based on the good user interface",
        list3:
          "· Complete: The strategy is described based on functional expressions, and developers can obtain enough information (including but not limited to user information, equipment, network, location, behavior, custom report data, etc.) to write strategy hit logic ",
        list4:
          "· Flexible: Hit judgment based on multiple methods at the same time",
      },
      item4: {
        title: "Simple configuration",
        subtitle:
          "Based on a friendly user interface, quickly configure MFA for specific applications",
        list1: "· One-click on/off MFA",
        list2:
          "· One-click to enable the default security policy, no need to understand the policy configuration, can also greatly improve application security",
        list3:
          "· Preset dozens of important and commonly used strategy hit conditions, which will take effect upon selection and can be used by non-engineers",
      },
    },
    performance: {
      title: "Adaptive MFA, higher performance choice",
      subtitle: `Compared with traditional MFA, "adaptive" MFA can choose to apply different MFA methods according to the current security situation, so as to ensure security while also taking into account the user experience. Adaptive MFA provides a more flexible and intelligent verification strategy.`,
      secondTitle: `When the user goes through the authentication process, "adaptive" MFA generates multiple "key elements" for the currently logged-in user`,
      item1: {
        title: "User attributes",
        subtitle:
          "Such as user name, password, user identity and other attributes and information of the user",
      },
      item2: {
        title: "Location awareness",
        subtitle:
          "Location awareness is divided into the virtual location (IP address) and physical location (country, region, etc.)",
      },
      item3: {
        title: "Request source",
        subtitle:
          "Judge the source of the current user’s request, such as hardware device information, the user’s current system, etc.",
      },
      item4: {
        title: "Biometrics",
        subtitle:
          "Use the user's biological information for identification, such as fingerprint information, face recognition, etc.",
      },
      item5: {
        title: "Behavior analysis",
        subtitle:
          "A series of user behaviors such as whether it comes from a commonly used login location, whether the wrong password is entered multiple times, and the user's previous operation records",
      },
    },
    example: {
      title: "MFA industry use cases",
      subtitle:
        "In general, we see a tendency to use MFA in industries dealing with sensitive data, such as insurance and banking. There is no additional identity layer in these vertical domains, so there is an urgent need for MFA.",
      description1:
        "MFA is one of the best ways to prevent accounts from being stolen. If an attacker wants to invade an account protected by MFA, he not only needs to steal credentials, but also needs to verify additional factors. MFA greatly increases the time and energy required by attackers to invade accounts, so it is difficult for them to carry out large-scale attacks.",
      description2:
        "Authing can centrally configure a variety of authentication factors other than passwords, including dynamic token, certificate, face, fingerprint and other biometrics. It can integrate a variety of common third-party authentication sources. At the same time, the developer API is provided to support other applications to use the identity authentication ability of IDaaS.",
      systems: {
        finace: "Financial system",
        item1: {
          title: "Ensure access to financial data",
          subtitle:
            "In order to protect financial data and online transactions from criminals, MFA of Authing is used to verify the identity of users.",
          list1:
            "When logging into financial websites and apps, the MFA of Authing sends authentication information to users' smartphones to prevent unauthorized access.",
          list2:
            "When conducting financial transactions, the MFA of Authing double verifies the user's identity to ensure the identity security of trading partners and protect online transactions from criminals.",
        },
        education: "Educational system",
        item2: {
          title: "Protecting higher education",
          subtitle:
            "Using the trusted MFA solution of Authing it provides secure application access for students and staff.",
          list1:
            "Authing verifies the user's identity through MFA, and checks the security status of the device before granting access to the web page and application, so as to ensure that only trusted users and devices can access the organization's website and application.",
          list2:
            "After the MFA is deployed to its teachers and students, it can improve the accuracy of identity authentication and ensure that students and staff will not be victims of phishing attacks.",
        },
        govenment: "Government affairs system",
        item3: {
          title: "Security for government agencies",
          subtitle: `Using the MFA solution of Authing, we can start the journey of "zero trusts", help government agencies reduce risks, and promote the realization of government modernization.`,
          list1:
            "Local governments rely on various tools to manage sensitive personal information and provide basic community services. Deploying the MFA of Authing can maintain the security of government applications and improve the security of government applications.",
          list2:
            "Authing protects against phishing and blackmail attacks by preventing devices from accessing applications without authorization. Government agencies can safely and easily access websites and applications to serve the community without managing complex IT environments.",
        },
      },
    },
  },
  buildAd: {
    banner: {
      title: "Microsoft AD Optimization Solution",
      subtitle:
        "In the past, enterprises relied on AD (Active Directory) for authenticating resource access, which is no longer sufficient today.",
      subtitle2:
        "Now you need a more flexible identity enhancement solution to match the rapid growth of your business.",
    },
    intro: {
      item1: {
        title:
          "Enhance AD to improve the efficiency of enterprise digital transformation",
        subtitle: "Traditional Active Directory Solutions",
        "descript1-title": "Only support LDAP, Kerberos protocol: ",
        descript1:
          "difficult to access more applications on and off the cloud in the future.",
        "descript2-title": "Single use scenario: ",
        descript2:
          "Difficult to achieve Single Sign-on (SSO), application integration, data synchronization, etc.",
        "descript3-title": "Doesn't meet the needs of the industries: ",
        descript3:
          "difficult to access non-local resources and cloud resources, can only do domain permissions control.",
        "descript4-title": "Low scalability and complex configuration: ",
        descript4:
          "Lack of API and expansion capability, high cost burden for IT operation and bug fixing, etc.",
      },

      item2: {
        title: "The future of the identity system",
        "descript1-title": "More convenient integration: ",
        descript1:
          " In addition to LDAP, it supports OIDC, OAuth2.0, SAML, CAS and other protocols, and access to 2000+ common applications.",
        "descript2-title": "More diverse functions: ",
        descript2:
          "Using Authing as a modern directory, it can achieve AD SSO, lifecycle management,MFA and other functions at the same time.",
        "descript3-title": "More fine-grained authorization: ",
        descript3:
          "Supports RBAC/ABAC model, application access authorization and other authorization.",
        "descript4-title": "Higher scalability: ",
        descript4:
          "Rich SDK/API, login component, Serverless capability, flexible to match business requirements and reduce O&M workload.",
      },

      item3: {
        title: "Authing Connector- AD Identity Solution",
        descript1:
          "Provide Windows AD-based authentication services for enterprise users, seamlessly migrating AD users and organizations.",
        descript2:
          "Let AD and Authing co-exist: AD manages the hardware layer and Authing manages the software business layer, supporting bi-directional data synchronization between the two.",
      },

      item4: {
        title: "The conversion is worth it",
        descript:
          "Choosing Authing means taking back control of the authentication process and data. Starting today, Authing can help you complete the transformation.",
      },
    },
    features: {
      title: "Rethinking the AD maturity model",
      axisX: "Business Modernity",
      axisY: "Business Agility",
      item1: {
        title: "Present situation",
        list1: "All users stored in AD",
        list2: "AD controls all machines and accesses them through GPO",
        list3: "SaaS uses independent login",
      },
      item2: {
        title: "Extending AD with the single sign-on",
        list1:
          "IDaaS is integrated with AD and supports single sign-on for SaaS and local applications",
        list2: "IDaaS centralized security policy",
        list3: "MFA protects applications and resources",
      },
      item3: {
        title: "Establishing IDaaS identity Center",
        list1:
          "IDaaS purchases employees directly from human resources and assigns them to AD",
        list2: "Local nonemployees managed by IDaaS",
        list3: "Device management solutions control end-user devices",
      },
      item4: {
        title: "Secure identity cloud",

        list1:
          "IDaaS controls access to all applications and resources through adaptive policies and password-free authentication",
        list2:
          "Device management and IDaaS solutions share device and user context",
        list3:
          "IDaaS protects access to servers and network resources (such as VPN and WiFi)",
        list4:
          "SaaS file synchronization and sharing solution replaces file server",
        list5: "Cloud Print Service replaces print server",
      },
    },
  },
  privateCloud: {
    banner: {
      title: "Private deployment of identity cloud",
      subtitle:
        "Authing is one trusted platform to secure every identity. Many of the world’s top 500 enterprises trust Authing’s software and APIs to sign in, authorize and manage users.",
    },
    resource: {
      title: "Resource Center",
      mirror: {
        title: "Privatization deployment plan",
        content:
          "If you need to privatize the deployment of Authing, click to learn about the deployment plan",
        "button-link": "View now",
      },
      docs: {
        title: "Quick start",
        content:
          "Easily integrate the identity system for your application and guide the deployment problems",
        "button-link": "View now",
      },
      "price-title": "Flexible pricing for companies and developers",
    },
    advantage: {
      title: "Our Advantages",
      item1: {
        title: "Improve the efficiency of operation management",
        content: `The internal of large enterprises and organizations usually divide business according to the dimensions of "region" and "department". Different businesses usually need to ensure independence. Authing uses multi tenant technology to help enterprises solve the problem of business and data isolation. Meanwhile, Authing's enterprise operation center can help you manage and operate tenants conveniently.`,
      },
      item2: {
        title: "Improve user experience with excellent identity service",
        content:
          "Identity management runs through all the services provided by enterprises for users. An excellent identity manage-ment scheme will capture and store user information in an all-round way from user registration and login, to tracking user preferences in services, and then to precision marketing.",
      },
      item3: {
        title: "Improve identity security and protect data assets",
        content:
          "Functions such as dynamic token, face recognition and other MFA can comprehensively improve the system access security and ensure the user access security.",
      },
      "customer-common":
        "“Compared with many manufacturers, we can feel the advantages of Authing. This is a product made through thinking”",
      "customer-link": "Read customer success stories",
      integrate: {
        title:
          "3 steps accelerates application development and integration for enterprise identity infrastructure:",
        item1:
          "In the early stage, we carried out detailed demand collection and research to deeply understand the business status of the enterprise. Combined with the actual scene, we sorted out the detailed construction scheme and project schedule of IDaaS.",
        item2:
          "After the scheme is confirmed, the authing kernel is deployed to the enterprise private cloud environment by using the advantages of Authing's cloud native architecture, and the existing 700 + API is used for flexible and fast secondary development until the delivery is completed.",
        item3:
          "Authing is not only a software provider, but also a business consulting partner of the enterprise. Authing has an experienced customer success team, which escorts the identity security of the enterprise in 7 * 24 hours, and provides technical and business consulting services for the enterprise.",
      },
    },
    question: {
      title: "Common problem",
      item1: {
        title: "How to choose the authentication method?",
        list1:
          "If you don't understand OAuth, OIDC, SAML, LDAP and other standard protocols, and the application security requirements are not high, it is recommended to use ordinary authentication.",
        list2:
          "If your application requires high security, whether you know the standard protocol or not, please use the standard protocol authentication.",
      },
      item2: {
        title: "What is Authing?",
        list1:
          "Authing provides professional authentication and authorization services for enterprises and developers in the cloud.",
        list2:
          "You can connect any platform application to Authing (whether it's a newly developed application or an old application). At the same time, you can customize the login mode of the application (such as email / password, SMS / verification code, social login, etc.).",
        list3:
          "You can choose our SDK or call related API to access your application according to the technology you use. When a user initiates an authorization request, Authing will help you authenticate their identity and return the necessary user information to your application.",
      },
      item3: {
        title: "Why use Authing?",
        list1:
          "You want to develop a cool program, then you want to add user authentication and authorization. You want your users to log in using wechat and GitHub. At the same time, you also want to track the registration source and activity data of users, so that you can do subsequent user growth.",
        list2:
          "You have made an API, and you want to use OAuth 2.0 to ensure the API security.",
        list3:
          "You have made a lot of applications, and you hope that the user data of these applications can be exchanged through single sign on.",
        list4:
          "You have made a JavaScript front-end application and a mobile application. You want these two client applications to be able to access your API safely.",
        list5: "You need to build a web application that supports SAML login.",
        list6:
          "You think the password is very fragile, so you want users to log in with one-time mobile phone verification code or email verification code.",
        list7:
          "If your user's password is leaked on other websites, you want to be informed so that you can inform your user to reset the password.",
        list8:
          "If a user fails to log in continuously, you want to prohibit their IP to prevent DDoS attack or brute force password cracking.",
        list9:
          "You are in a large enterprise that wants to combine its existing enterprise directory to allow employees to log in to various internal and third-party applications using their existing enterprise credentials.",
        list10:
          "You don't want (or don't know how) to implement your own user management solution. You don't want to develop repetitive UI such as password reset, create, configure, block and delete users. You just want to focus on your own business development and product design. At this time, you can choose Authing as the authentication middleware.",
        list11:
          "You want to enforce multiple authentication when users want to access sensitive data.",
        list12:
          "You are looking for an identity solution that can help you meet the growing compliance requirements of soc2, gdpr, openid connect, etc.",
        list13:
          "You want to use data analysis to track users on your website or application. You also want to use this data to expand customer acquisition channels, measure user retention, and gradually improve the registration process.",
      },
    },
  },
  auth0: {
    banner: {
      title: "Move from Auth0",
      description: `Using Auth0 in China can pose a number of challenges. For this reason, Authing is offering a "Move from Auth0 Solution" which can  meet the localization needs of enterprises and developers.`,
      solution: "Download Solution",
      consult: "Solution Consultation",
    },
    replace: {
      title: "Why Authing instead of Auth0?",
      subtitle:
        "Entering the Chinese market requires more localized authentication and access management services.",
      authing: {
        title: "Using Authing",
        subtitle: "Enjoy a more localized service",
        item1: {
          title: "Fast global response time",
          descript:
            "Authing has been deployed in multiple nodes around the world, and static files are globally accelerated using AliCloud CDN; the average response time is only 500 milliseconds, whether domestic or foreign.",
        },
        item2: {
          title: "Complete application ecology",
          descript:
            "Authing is pre-integrated with many common identity sources from home and abroad, including WeChat, Alipay, Weibo, Google, Apple, Twitter, etc., and can be configured in 500 milliseconds.",
        },
        item3: {
          title: "Diverse cloud service choices",
          descript: `Authing supports multiple cloud deployments such as Huawei Cloud, Ali Cloud, Tencent Cloud, Amazon Cloud, Microsoft Cloud, etc. It is completely "cloud neutral" and enterprises have more diversified cloud ecological choices.`,
        },
        item4: {
          title: "Active customer service",
          descript:
            "For enterprise customers, Authing provides dedicated customer success managers who can respond within 20 minutes on average, while for individual developers, there is a well-established developer forum to answer questions and solve problems.",
        },
      },
      auth0: {
        title: "Using Auth0",
        subtitle: "Facing the challenges of Chinese localization",
        item1: {
          title: "Slow response time",
          descript:
            "Auth0 has a good reputation worldwide, but has not yet entered the Chinese market, so the average response time in China is long, taking about 2.7 seconds. However, the slow response time will affect the user experience.",
        },
        item2: {
          title: "Lacking third-party identity sources",
          descript: `Auth0 lacks support for localized "third-party identity sources" such as WeChat, Alipay, etc. However, in China, third-party login through these applications is essential.`,
        },
        item3: {
          title: "Limited cloud deployment support",
          descript:
            "Auth0 only supports deployment in Amazon Cloud and Microsoft Cloud, but does not yet support Chinese local cloud service providers such as Ali Cloud, Tencent Cloud and Huawei Cloud, which are chosen by a large number of enterprises.",
        },
        item4: {
          title: "Limited after-sales service",
          descript:
            "Currently, Auth0 has not provided official support services in China,  and the community responds slowly with a time difference.",
        },
      },
    },
    table: {
      title: `Create "User First" IDaaS with Authing`,
      description2: `Compared to Auth0, Authing Identity Cloud offers the same comprehensive IDaaS capabilities and 1000+ developer-friendly APIs/SDKs; and achieves better results at a lower cost.`,
      description1: "",
      learnMore: " Learn more",
      fun: "Function",
      fun1: "Pricing",
      fun2: "Chinese Application Ecology",
      fun3: "Custom Password Policy",
      fun4: "ABAC",
      fun5: "SaaS",
      fun6: "Private Deployment",
      fun7: "Users management ",
      fun8: "OIDC, SAML, etc.",
      fun9: "Tenants",
      fun10: "M2M",
      fun11: "SSO",
      fun12: "MFA",
      auth0Remark: "Enterprise",
      authingRemark: "Professional/Enterprise",
    },
    transfer: {
      title: "Move to Authing without burden",
      description2:
        "Authing has run through several best practices for companies that use Auth0 overseas but want to use Authing for their Chinese localization needs as they expand into China.",
      description1: "",
      consult: " Contact sales",
      step1: {
        title: "Evaluate migration costs",
        subtitle:
          "For example, we helped a global meta-universe social platform with 20,000 MAUs and 3 apps migrate their data to Authing. First, we will analyze the cost in terms of user & role information, permission information, app information, SDK, etc.",
      },
      step2: {
        title: "Migrate stock data",
        subtitle:
          "Then, to ensure the replacement of Auth0 has not affected the original business, Authing combines the corresponding user data, role data, application data and permission data structures through the APIs of both parties to minimize the migration cost.",
      },
      step3: {
        title: "Synchronize incremental data",
        subtitle:
          "In addition, for incremental data synchronization, Authing allows event-based or timer-based synchronization through an underlying interface supported by both parties, making the transition to use more trouble-free.",
      },
      step4: {
        title: "Complete migration painlessly",
        subtitle:
          "Migrating to Authing enables companies to better meet China's data security and compliance terms. And with the API/SDK provided by Authing, it is more secure and efficient to achieve fast go-live and connect user data.",
      },
    },
  },
  okta: {
    banner: {
      title: "Move from Okta",
      description: `Authing can cover all the features provided by Okta, and is more in line with the market needs of mainland China. At present, many enterprises have chosen to replace Okta with Authing.`,
      solution: "Download Solution",
      consult: "Solution Consultation",
    },
    replace: {
      title: "Why Authing instead of Okta?",
      subtitle:
        "Entering the Chinese market requires more localized authentication and access management services.",
      okta: {
        title: "Using Okta",
        subtitle: "Face challenges of Chinese localization",
        item1: {
          title: "Unstandardized data security",
          descript:
            "Regulations in mainland China have strict requirements for security and user data protection. Using Okta directly in China requires solving multiple compliance issues on its own.",
        },
        item2: {
          title: "Slow Localized Response Time",
          descript:
            "Okta has not yet entered the mainland Chinese market, with a longer average response time and high latency in the country, which will affect the user login experience.",
        },
        item3: {
          title: "Lacking third-party identity sources",
          descript: `Okta lacks support for localized "third-party identity sources" such as WeChat, Alipay, etc. But in China, third-party login through these applications is essential.`,
        },
        item4: {
          title: "Limited after-sales service",
          descript:
            "At present, Okta does not provide official support services in mainland China, with slow response from the community and time difference restrictions.",
        },
      },
      authing: {
        title: "Using Authing",
        subtitle: "Enjoy more localized services",
        item1: {
          title: "Qualified data security",
          descript: `Authing has ISO, three-level protection, GDPR and other data security certifications, and was included in the "China Network Security Industry White Paper" at the beginning of the launch.`,
        },
        item2: {
          title: "Fast global response time",
          descript:
            "Authing has been deployed in multiple nodes around the world, and static files are globally accelerated using AliCloud CDN; the average response time is only 500 milliseconds, whether domestic or foreign.",
        },
        item3: {
          title: "Complete application ecology",
          descript:
            "Authing is pre-integrated with many common identity sources from home and abroad, including WeChat, Alipay, Weibo, Google, Apple, Twitter, etc., and can be configured in 500 milliseconds.",
        },
        item4: {
          title: "Active customer service",
          descript:
            "For enterprise customers, we provide exclusive customer success managers who can respond on average within 20 minutes; for individual developers, there is also a well-established developer forum to answer user questions.",
        },
      },
    },
    marquee: {
      item1: {
        title1: "A globally online education platform",
        desc1:
          "This platform serves 78M users in 180 countries, offering courses & teaching opportunities",
        title2: "Quickly connect to 3rd-party applications",
        desc2:
          "Authing's comprehensive product features and professional service team helped us quickly land in the Chinese mainland market in a limited time, meeting stringent compliance requirements and connecting to apps like WeChat and Weibo.",
      },
      item2: {
        title1: "Alpha Cen",
        desc1:
          "Originating from Silicon Valley, with full-stack R&D capabilities for chip products",
        title2: "Efficiently unify identity authentication",
        desc2:
          "After returning to China, we actively sought a product to benchmark Okta services. Authing provides interfaces and readable docs, allowing us to build a complete identity authentication management platform easily.",
      },
      item3: {
        title1: "A renowned provider of cross-border logistics",
        desc1:
          "Focusing on international logistics for 10 years, with millions of packages received and processed",
        title2: "Conveniently improving login experience",
        desc2:
          "We considered Okta for mainland China, but high latency and a poor login experience caused us to choose Authing. Authing offers similar performance domestically and abroad, this helps us maintain a unified system in and outside China.",
      },
    },

    table: {
      title: "Expand your global business efficiently with Authing",
      description1:
        "Compared to Okta, Authing Identity Cloud provides the same comprehensive IDaaS capabilities,",
      description2: "and more to meet the localization needs of China.",
      learnMore: "Learn more",
      showDemo: "Let's talk",
      remark: "Uncertain",
      fun: "Function",
      fun1: "Chinese application ecology",
      fun2: "Official services in mainland China",
      fun3: "SMS OTP coverage rate in mainland China",
      fun4: "SMS OTP arrival time in mainland China",
      fun5: "Chinese cloud services",
      fun6: "Overseas application ecology",
      fun7: "User management API",
      fun8: "Pre-integrated SDKs for various languages",
      fun9: "OIDC、SAML、CAS、Oauth2.0",
      fun10: "Custom password policies",
      fun11: "Automated identity synchronization",
      fun12: "Webhooks",
      fun13: "Custom domains",
      fun14: "Face recognition",
      fun15: "Automated identity management workflows",
      fun16: "M2M",
      fun17: "Single sign-on",
      fun18: "MFA",
    },
  },
};
